import { useCallback } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { ClientFilters } from '../types/client.types';

const defaults: ClientFilters = {
  s: undefined,
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  companyId: undefined,
  type: undefined,
  priority: undefined,
};

const numberFields: (keyof ClientFilters)[] = ['limit', 'page', 'companyId'];

export function useClientFilters() {
  const { updateFilter: baseUpdateFilter, ...rest } = useUrlFilters<ClientFilters>({
    defaults,
    numberFields,
  });

  // Auto-reset page when any filter other than page or limit changes
  const updateFilter = useCallback(
    <K extends keyof ClientFilters>(key: K, value: ClientFilters[K]) => {
      baseUpdateFilter(key, value, key !== 'page' && key !== 'limit');
    },
    [baseUpdateFilter]
  );

  return { ...rest, updateFilter };
}
